import { BankingTransferFilter } from 'generated/resources/graphql'

import useFilters from 'modules/core/components/DataTable/hooks/useFilters'
import i18n from 'modules/core/lib/i18n'

import { buildTransfersCountWidget } from 'modules/banking/components/Widgets/TransferCountWidget'
import { buildTransfersAmountWidget } from 'modules/banking/components/Widgets/TransfersAmountWidget'
import { formattedAmount } from 'modules/banking/lib/paymentHelpers'
import { DataTableWidgetInsights } from 'modules/finance/components/Widgets/common/widgets'

interface TransferInsightsProps {
  defaultCurrency: string
  locale: string
}

export const TransferInsights = ({ defaultCurrency, locale }: TransferInsightsProps) => {
  const { getFiltersVariables } = useFilters()

  const amountFormatter = (value: unknown) =>
    formattedAmount({ amountCents: Number(value), currency: defaultCurrency, locale })
  const dataTableFilters: BankingTransferFilter = getFiltersVariables().filter ?? {}

  const widgets = [
    buildTransfersAmountWidget({
      widgetTitle: i18n.t('finance.overview.outstanding_payments.total_value'),
      filters: { currency: { in: [defaultCurrency] }, ...dataTableFilters },
      prepareDataArgs: { amountFormatter },
    }),
    buildTransfersCountWidget({
      widgetTitle: i18n.t('finance.overview.payments.on_time'),
      transferFilters: { currency: { in: [defaultCurrency] }, ...dataTableFilters },
      queryArgs: {
        onlyPending: true,
        dueThisWeek: false,
        onTime: true,
        overdue: false,
      },
    }),
    buildTransfersCountWidget({
      widgetTitle: i18n.t('finance.overview.payments.due_this_week'),
      transferFilters: { currency: { in: [defaultCurrency] }, ...dataTableFilters },
      queryArgs: {
        onlyPending: true,
        dueThisWeek: true,
        onTime: false,
        overdue: false,
      },
    }),
    buildTransfersCountWidget({
      widgetTitle: i18n.t('finance.overview.payments.overdue'),
      transferFilters: { currency: { in: [defaultCurrency] }, ...dataTableFilters },
      queryArgs: {
        onlyPending: true,
        dueThisWeek: false,
        onTime: false,
        overdue: true,
      },
    }),
  ]

  return <DataTableWidgetInsights useBox widgets={widgets} widgetWidth="full" />
}
